import script from "./DMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./DMenuItem.vue?vue&type=style&index=0&id=49a829d4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49a829d4"]])

export default __exports__